<div class="bg-white px-4 py-2">
  <form [formGroup]="filterForm">
    <div
      class="flex-wrap align-items-center"
      style="
        grid-gap: 15px;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
      "
    >
      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="All Suppliers"
          [options]="suppliers"
          formControlName="supplierIds"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="All Assignees"
          [options]="users"
          formControlName="assigneeUserIds"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="Actioned By Anyone"
          [options]="users"
          formControlName="actionedByUserIds"
        ></p-multiSelect>
      </div>

      <div>
        <p-multiSelect
          class="filter-multiselect narrow-multiselect"
          defaultLabel="All Actions"
          [options]="actions"
          formControlName="actions"
        ></p-multiSelect>
      </div>

      <div>
        <p-calendar
          placeholder="From"
          dateFormat="dd/mm/yy"
          appendTo="body"
          [showButtonBar]="true"
          formControlName="dateFrom"
        ></p-calendar>
      </div>

      <div>
        <p-calendar
          placeholder="To"
          dateFormat="dd/mm/yy"
          appendTo="body"
          [showButtonBar]="true"
          formControlName="dateTo"
        ></p-calendar>
      </div>

      <div class="flex gap-2">
        <div class="flex-shrink-1">
          <button class="button-style" type="button" (click)="search()">
            <i class="fa fa-search"></i>&nbsp;Search
          </button>
        </div>

        <div class="flex-shrink-1">
          <button
            class="button-style ui-button-tertiary transparent"
            type="button"
            (click)="resetFilters()"
          >
            <i class="fa fa-undo"></i>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="px-4 py-2">
  <div class="mb-2 bold-text" *ngIf="!isLoading">
    Showing {{ data?.total ?? 0 }} matching {{ (data?.total ?? 0) === 1 ? 'change' : 'changes' }}
  </div>

  <p-table
    [value]="data?.entries ?? []"
    [lazy]="true"
    (onLazyLoad)="loadLazy($event)"
    [loading]="isLoading"
    [paginator]="true"
    [rows]="pageSize"
    [totalRecords]="data?.total ?? 0"
    [rowsPerPageOptions]="[25, 50, 100]"
    [first]="pageIndex * pageSize"
    styleClass="assignment-history-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 170px">When</th>
        <th class="action-cell" style="width: 130px">Action</th>
        <th>Supplier</th>
        <th>Assignee</th>
        <th>Previously Assigned</th>
        <th>Actioned By</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-entry>
      <tr [class.unassignment-row]="isUnassignment(entry)">
        <td>
          <div class="bold-text">{{ entry.dateActioned | datex : 'ddd, DD MMM YYYY' }}</div>
          <div class="text-sm text-gray-600">{{ entry.dateActioned | datex : 'HH:mm' }}</div>
        </td>

        <td class="action-cell">
          <pill
            [backgroundColour]="isUnassignment(entry) ? 'bg-gray-200' : 'bg-blue-100'"
            textColour="text-gray-700"
          >
            <span>{{ actionLabel(entry) }}</span>
          </pill>
        </td>

        <td>
          <a
            class="text-blue-500"
            target="_blank"
            href="/app/supplier-information/{{ entry.supplierId }}"
            >{{ entry.supplierName }}</a
          >
        </td>

        <td>
          <span [class.line-through]="isUnassignment(entry)">{{ entry.assigneeUserName }}</span>
          <div class="text-sm text-gray-600" *ngIf="isUnassignment(entry)">was removed</div>
        </td>

        <td>
          <span *ngIf="entry.previousAssigneeUserName">{{ entry.previousAssigneeUserName }}</span>
          <span class="text-gray-600" *ngIf="!entry.previousAssigneeUserName">&mdash;</span>
        </td>

        <td>{{ entry.actionedByUserName }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center py-4">
          <h4 class="my-0">
            No assignment changes found matching the criteria. Change the filters and try again.
          </h4>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
